__turbopack_context__.v({
  "icon": "prgaGW_icon",
});
